<template>
    <div class="schedule">
        <div class="schedule__header">
            <h3 class="schedule--title title01">
                <sub class="schedule--title-sub">Advance Reservation Recommended</sub>
                진료 전 예약을 통해 보다 편리하게<br class="pc-none"> 서비스를 이용하실 수 있습니다.
            </h3>
            <div class="schedule__legend-wrap">
                <ul class="schedule__legend">
                    <li class="schedule__legend-item">
                        <span class="schedule__legend-icon schedule__legend-icon--outpatient"></span> 외래진료
                    </li>
                    <li class="schedule__legend-item">
                        <span class="schedule__legend-icon  schedule__legend-icon--clinic"></span> 클리닉
                    </li>
                    <li class="schedule__legend-item">
                        <span class="schedule__legend-icon  schedule__legend-icon--dayoff">휴</span> 휴진
                    </li>
                    <li class="schedule__legend-item">
                        <span class="schedule__legend-icon  schedule__legend-icon--holiday">공</span> 공휴일
                    </li>
                </ul>
            </div>
        </div>
        <kr_DoctorScheduleCard :doctorList="scheduleList" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            scheduleList: [],
            drSids: '1019616,1001808,1001705,1002748,1015451,1024351,1022642,1005698',
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.getScheduleInfo()
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            const legendWrap = document.querySelector('.schedule__legend-wrap');
            const legend = document.querySelector('.schedule__legend');
            if (!legendWrap || !legend) return;

            const rect = legendWrap.getBoundingClientRect();
            const offsetTop = rect.top;

            const triggerOffset = window.innerWidth >= 720 ? 88 : 60;

            if (offsetTop <= triggerOffset) {
                legend.classList.add('on');
            } else {
                legend.classList.remove('on');
            }
        },
        getScheduleInfo(){
            const param = {
                startIndex: 1,
                pageRow: 999,
                hospId: this.$store.getters.getHost,
                // deptCd: this.deptCd,
                drSids: this.drSids,
                langCd: this.$store.getters.getLang
            }
            this.axios.get(this.api.doctor.scheduleInfo, {params: param})
            .then(res => {
                if(res.data.doctorTotCnt > 0){
                    this.scheduleList = res.data.doctorList
                    const drSidsArr = this.drSids.split(',')
                    this.scheduleList.sort((a, b) => {
                        return drSidsArr.indexOf(a.drSid) - drSidsArr.indexOf(b.drSid)
                    })
                }
            })
        },
    }
}
</script>